import { render } from "./EditIcon.svg?vue&type=template&id=2d65c586"
const script = {}
script.render = render

export default script